module.exports = __webpack_public_path__ + "static/media/trophy-icon.be802de2.png";